import { useTranslation } from "react-i18next"
import { useQuery } from "react-query";
import Select from "react-select"
import { getEmployes } from "../../../../../MyApi/sb/employes";
import { getBranches } from "../../../../../MyApi/sb/branches";

const SubTaskFilter = ({branchId ,employId, setSbEmployeId ,setSbBranchId , setDateFrom , setDateTo ,setStatus}) => {
const {t} =useTranslation()
const page = 0;
const EmployeQuery = useQuery(["getEmployes", page, branchId], () =>
  getEmployes(page, branchId)
);
const branchQuery = useQuery(["getbranches", page], () => getBranches(page));

const employes = EmployeQuery.data?.data || [];
const branches = branchQuery.data?.data || [];

const handelEmployeChange = (selectedEmploye) => {
  const employId = selectedEmploye ? selectedEmploye.id : 0;
  setSbEmployeId(employId);
};
const handelBranchChange = (selectedBranch) => {
  const branchId = selectedBranch ? selectedBranch.id : 0;
  setSbBranchId(branchId);
};
const handleSearchChange=(e)=>{
    const {value} =e.target;
    const {name} =e.target;
    if(name === "status"){
        setStatus(value)
    }
    if(name === "date_to"){
        setDateTo(value)
    }
    if(name ==="date_from"){
        setDateFrom(value)
    }
}

  return (
    <div className='card'> 
    <div className='card-body'>
     <div className="row">
     <div className='col-3 col-md'>
     <label htmlFor="">{t("Status")}</label>
       <select className='form-select' name="status ">
        <option value="">All</option>
        <option value="pendeing">pendeing</option>
        <option value="completed">completed</option>
        <option value="started">started</option>
        <option value="onreview">onreview</option>
        <option value="expired">expired</option>
       </select>
     </div>
     <div className='col-3 col-md'>
     <label htmlFor="">{t("Date from")}</label>
       <input name="date_from" type="date" className='form-control'  onChange={handleSearchChange}/>
     </div>
     <div className='col-3 col-md'>
     <label htmlFor="">{t("DateTo")}</label>
       <input name="date_to" type="date" className='form-control' onChange={handleSearchChange}/>
     </div>
     <div className='col-3 col-md'>
     <label htmlFor="">{t("Employes")}</label>
       <Select  
            options={employes}
              getOptionValue={(e) => e.id}
              getOptionLabel={(e) => e.name_ar}
              onChange={handelEmployeChange}
              placeholder="search" />
     </div>
     <div className='col-3 col-md'>
     <label htmlFor="">{t("Branches")}</label>
        <Select    options={branches}
              getOptionValue={(e) => e.id}
              getOptionLabel={(e) => e.name}
              onChange={handelBranchChange}
              placeholder="search"/> 
     
     </div>
        </div>   
    </div>
   
    </div>
  )
}

export default SubTaskFilter